import React, { useState, useEffect, useRef } from "react";
import { Input, Form, Spin } from "antd";
import { axiosInstance } from "../../utils/axiosInstance";
import { API_ENDPOINTS } from "../../utils/constants";
import { convertDecimalToFloat, formatNumber, formatValue } from "../../utils";

const COLUMN_VALUE_MATCHES: { [key: string]: string } = {
	"Min. Ücret": "minPayment",
	"Max. Ücret": "maxPayment",
	"Para Birimi": "paymentCurrency",
	"Ödeme Tipi": "paymentNetType",
};

const MIN_PAYMENT = "Min. Ücret";
const MAX_PAYMENT = "Max. Ücret";
const PAYMENT_NET_TYPE = "Ödeme Tipi";
const PAYMENT_CURRENCY = "Para Birimi";

const EditableCell = ({
	title,
	editable,
	children,
	record,
	handleSave,
	inputType,
	...restProps
}: {
		title: string;
		editable: boolean;
		children: React.ReactNode;
		record: any;
		inputType?: string;
		handleSave: (record: any) => void;
}) => {
	const [inputValue, setInputValue] = useState(record ?
		inputType === "number" ?
			formatNumber(record[COLUMN_VALUE_MATCHES[title]]) :
			record[COLUMN_VALUE_MATCHES[title]] : ""
	);
	const [loading, setLoading] = useState(false);

	let inputRef: any = null;

	const setRef = (input: any) => {
		inputRef = input;
	};

	useEffect(() => {
		if (editable) {
			inputRef.current?.focus();
		}
	}, [editable]);

	const save = async (e: React.KeyboardEvent<HTMLInputElement> | React.FocusEvent<HTMLInputElement>) => {
		setLoading(true);
		record[MIN_PAYMENT] = record.minPayment;
		record[MAX_PAYMENT] = record.maxPayment;
		record[PAYMENT_NET_TYPE] = record.paymentNetType;
		record[PAYMENT_CURRENCY] = record.paymentCurrency;
		const target = e.target as HTMLInputElement;
		record[title] = target.value;
		try {
			await axiosInstance.put(API_ENDPOINTS.PAYMENT_SUGGESTION_DEFINITION, {
				id: record.id,
				minPayment: convertDecimalToFloat(record[MIN_PAYMENT]) !== null ? Number(convertDecimalToFloat(record[MIN_PAYMENT])) : null,
				maxPayment: convertDecimalToFloat(record[MAX_PAYMENT]) !== null ? Number(convertDecimalToFloat(record[MAX_PAYMENT])) : null,
				paymentCurrency: record[PAYMENT_CURRENCY],
				paymentNetType: record[PAYMENT_NET_TYPE]		
			});
			record.minPayment = record[MIN_PAYMENT];
			record.maxPayment = record[MAX_PAYMENT];
			record.paymentCurrency = record[PAYMENT_CURRENCY];
			record.paymentNetType = record[PAYMENT_NET_TYPE];
		} catch (errInfo) {
			console.log("Save failed:", errInfo);
		} finally {
			setLoading(false);
		}
	};


	let childNode = children;

	if (editable) {
		childNode = (
			<Form.Item
				style={{ margin: 0 }}
			>
				<Spin spinning={loading}>
					<Input
						ref={setRef}
						onPressEnter={save}
						onBlur={save}
						value={inputValue}
						onChange={(e) => {
							const input = e.target.value;
							const formattedInput = inputType === "number" ? formatValue(input) : input;
							if (inputType === "number" && formattedInput.length <= 14) {
								setInputValue(formattedInput);
							} else if (inputType === "text" && formattedInput.length <= 1000) {
								setInputValue(formattedInput);
							}
						}}
					/>
				</Spin>
			</Form.Item>
		);
	}

	return <td {...restProps}>{childNode}</td>;
};

export default EditableCell;